import { render } from "./QAQCOverviewShimmer.vue?vue&type=template&id=8bd857a2"
import script from "./QAQCOverviewShimmer.vue?vue&type=script&lang=js"
export * from "./QAQCOverviewShimmer.vue?vue&type=script&lang=js"

import "./QAQCOverviewShimmer.vue?vue&type=style&index=0&id=8bd857a2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__